import { useQuery } from "@tanstack/react-query";
import { z } from "zod";

import { apiGet } from "./client";

/**
 * IdeaSoft kurulum uclari — /api/v2/ideasoft/* (backend baska bir ajan
 * tarafindan yaziliyor, bkz. gorev talimati B). `GET /install` ikas'taki
 * gibi bir 302 REDIRECT'tir (JSON donmez) — bu yuzden fetch ile cagrilmaz;
 * /kurulum sihirbazi `window.location.assign(ideasoftInstallUrl())` ile TAM
 * SAYFA yonlendirme yapar (OAuth akisi ayni sekmede devam eder). Kimlik
 * bilgileri (Client ID/Secret) ise ikas'in aksine mevcut genel
 * `/tenant/credentials` ucuyla (settings.ts) `ideasoft_client_id`/
 * `ideasoft_client_secret` anahtarlariyla kaydedilir — Ticimax formuyla
 * ayni desen.
 */

export function ideasoftInstallUrl(): string {
  return "/api/v2/ideasoft/install";
}

export const ideasoftStatusSchema = z.object({
  connected: z.boolean(),
  store_url: z.string().nullable(),
  connected_at: z.string().nullable(),
  token_expires_at: z.string().nullable(),
});
export type IdeasoftStatus = z.infer<typeof ideasoftStatusSchema>;

export function fetchIdeasoftStatus(): Promise<IdeasoftStatus> {
  return apiGet("/api/v2/ideasoft/status", ideasoftStatusSchema);
}

/**
 * Backend endpoint'i henuz yoksa (404/hata) — Kurulum sihirbazini
 * KIRMAMASI icin sessizce "bagli degil" durumuna duser (retry yok, ikas'taki
 * `ikas.store_name` ayarina esdeger davranis).
 */
export function useIdeasoftStatusQuery(enabled = true) {
  return useQuery({
    queryKey: ["ideasoft", "status"],
    queryFn: fetchIdeasoftStatus,
    enabled,
    retry: false,
  });
}
